<template>
  <!-- FIXME: inline style についてはデザインを当てる際に修正する -->
  <div class="gift-box__ticket" style="width: 350px">
    <a :href="url" class="ticket">
      <div class="ticket-box">
        <span class="ticket-image">
          <ImgLazy
            :image-url="itemSkuImage"
            :alt-text="itemSkuName"
            aspect-ratio="1 / 1"
          />
        </span>
        <span class="ticket-info">
          <span class="ticket__item-name">
            {{ itemSkuName }}
          </span>
          <span class="ticket__item-min-unit">
            {{ itemSkuPrice }}
          </span>
          <span class="ticket__company--small">
            {{ brandName }}
          </span>
        </span>
        <span class="ticket-giftee-asterisk"></span>
      </div>
    </a>
  </div>
</template>

<script>
import ImgLazy from '../../atoms/images/ImgLazy.vue'

export default {
  components: {
    ImgLazy
  },
  props: {
    url: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: true
    },
    itemSkuImage: {
      type: String,
      required: true
    },
    itemSkuPrice: {
      type: Number,
      required: true
    },
    brandName: {
      type: String,
      required: true
    },
    isLoadingTicket: {
      type: Boolean,
      required: true,
      default: false
    }
  }
}
</script>
